import LoadingGIF from '../Icons/Spinner-0.8s-200px.svg';

function CircularLoading({ height, width, color, className }) {
  return (
    <img
      height={height || '200px'}
      width={width || '200px'}
      src={LoadingGIF}
      alt="Loading"
      color={color || ''}
      className={className || ''}
    />
  );
}

export default CircularLoading;
